import { type AttributeFilterInput } from '@/generated'
import { type AppliedFilters, isAppliedAttributeFilter, stripTypenames } from '@/types/search'

/** Returns a list of attribute filters from the applied list */
export const getAttributeFromAppliedFilters = (
  appliedFilters: AppliedFilters
): AttributeFilterInput[] => {
  return stripTypenames(appliedFilters.filter(isAppliedAttributeFilter))
}
